<template>
	<div class="exhibitor-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader v-if="this.isLoading" v-bind="attrs" type="card" />

			<div v-else-if="exhibitor">
				<!-- Основная информация -->
				<div v-if="exhibitor.partner_logo" class="exhibitor-page__content">
					<div class="exhibitor-page__logo-wrapper">
						<img
							class="exhibitor-page__logo"
							:src="exhibitor.partner_logo"
							alt="partner logo"
						/>
					</div>
				</div>
				<div v-if="exhibitor.partner_name" class="exhibitor-page__name-location mt-2">
					<p class="mb-0">
						<span class="exhibitor-page__info-name-label"> Exhibitor Name </span>
						<span class="exhibitor-page__info-name ml-3">
							{{ exhibitor.partner_name }}
						</span>
					</p>
					<p
						v-if="exhibitor.partner_location"
						class="exhibitor-page__info-location"
						:style="{ marginTop: exhibitor.partner_site_url ? '12px' : '24px' }"
					>
						<Icon type="pin" :size="14" color="#9B9B9B" :pr="8" />
						<span class="exhibitor-page__info-location-value">
							{{ exhibitor.partner_location }}
						</span>
					</p>
				</div>
				<!--				buttons section-->
				<div :class="buttonsClass">
					<!--					contact-->
					<div v-if="hasContactEmail" class="exhibitor-page__buttons__groups">
						<a
							class="exhibitor-page__info-site"
							:href="`mailto:${exhibitor.partner_contact_email}`"
							target="_blank"
						>
							<Icon
								type="email"
								:size="24"
								stroke-color="var(--accent-color)"
								class="exhibitor-page__icon"
							/>
							<span class="exhibitor-page__info-site-label">Contact</span>
						</a>
					</div>
					<div v-if="hasSiteUrl" class="exhibitor-page__buttons__groups">
						<a
							class="exhibitor-page__info-site"
							:href="exhibitor.partner_site_url"
							target="_blank"
						>
							<Icon
								type="link"
								:size="24"
								color="var(--accent-color)"
								class="exhibitor-page__icon"
							/>
							<span class="exhibitor-page__info-site-label">Website</span>
						</a>
					</div>
					<div v-if="mapPartners" class="exhibitor-page__buttons__groups">
						<a
							class="exhibitor-page__info-site"
							:href="mapPartners"
							rel="noopener noreferrer"
							target="_blank"
						>
							<Icon
								type="pin"
								stroke-color="var(--accent-color)"
								:size="24"
								class="exhibitor-page__icon"
							/>
							<span class="exhibitor-page__info-site-label">Map It</span>
						</a>
					</div>
					<!--					book mark button-->
					<div class="exhibitor-page__buttons__groups" @click="bookmarksToggle">
						<a class="exhibitor-page__info-site">
							<Icon
								v-if="followStatus"
								type="bookmark"
								:size="24"
								color="var(--accent-color)"
								class="exhibitor-page__icon"
							/>
							<Icon
								v-else
								type="bookmark_empty"
								:size="24"
								color="var(--accent-color)"
								class="exhibitor-page__icon"
							/>
							<span class="exhibitor-page__info-site-label">{{
									followStatus ? 'Bookmarked' : 'Bookmark'
								}}</span>
						</a>
					</div>
				</div>
				<!--				note add-->
				<div
					:class="[
						'exhibitor-page__note-add mt-2',
						{ 'padding-all': !isEditing, 'padding-top-sides': isEditing },
					]"
				>
					<h3 class="exhibitor-page__title">Note</h3>
					<div class="exhibitor-page__note-add__text-wrapper" v-if="!isEditing">
						<span class="exhibitor-page__note-add__text" @click="editNote">
							{{ follow_note }}
						</span>
						<div class="align-self-end" v-if="follow_note.trim() !== ''">
							<button
								class="exhibitor-page__clear_btn elevation-0"
								@click="clearNote"
							>
								clear
							</button>
						</div>
					</div>
					<div v-if="isEditing" class="comment-form__input-wrapper">
						<v-textarea
							ref="follow_note_input"
							label="Add Note..."
							auto-grow
							v-model="follow_note"
							class="exhibitor-page__note-add__textarea"
							required
							rows="1"
							@keydown.enter.prevent="saveNote"
							@blur="onBlur"
						></v-textarea>
					</div>
				</div>

				<!-- Контактная информация -->
				<div v-if="contactInfoVisible" class="exhibitor-page__contact mt-2">
					<div class="exhibitor-page__section">
						<h3 class="exhibitor-page__title">Contact Info</h3>
						<div>
							<p
								v-if="exhibitor.partner_contact_name"
								class="exhibitor-page__section-row mb-3"
							>
								<span class="exhibitor-page__section-row-title"> Name </span>
								<span class="exhibitor-page__section-row-value">
									{{ exhibitor.partner_contact_name }}
								</span>
							</p>
							<p
								v-if="exhibitor.partner_contact_title"
								class="exhibitor-page__section-row mb-3"
							>
								<span class="exhibitor-page__section-row-title"> Title </span>
								<span class="exhibitor-page__section-row-value">
									{{ exhibitor.partner_contact_title }}
								</span>
							</p>
							<p
								v-if="exhibitor.partner_contact_phone"
								class="exhibitor-page__section-row mb-3"
							>
								<span class="exhibitor-page__section-row-title"> Phone </span>
								<span class="exhibitor-page__section-row-value">
									{{ exhibitor.partner_contact_phone }}
								</span>
							</p>
							<p
								v-if="exhibitor.partner_contact_email"
								class="exhibitor-page__section-row mb-3"
							>
								<span class="exhibitor-page__section-row-title"> Email </span>
								<span class="exhibitor-page__section-row-value">
									{{ exhibitor.partner_contact_email }}
								</span>
							</p>
							<p v-if="locationInfo" class="exhibitor-page__section-row mb-0">
								<span class="exhibitor-page__section-row-title"> Location </span>
								<span class="exhibitor-page__section-row-value">
									{{ locationInfo }}
								</span>
							</p>
						</div>
					</div>
				</div>
				<!--				 Описание -->
				<div v-if="descriptionVisible" class="exhibitor-page__descriptions-section mt-2">
					<div class="exhibitor-page__section">
						<h3 class="exhibitor-page__title">Description</h3>
						<p
							ref="description"
							class="exhibitor-page__description"
							:style="{
								overflow: isCollapsed ? 'hidden' : 'visible',
								display: '-webkit-box',
								WebkitLineClamp: isCollapsed ? 5 : 'unset',
								WebkitBoxOrient: 'vertical',
							}"
						>
							{{ exhibitor.partner_description }}
						</p>
						<div
							v-if="isShowAllButtonVisible"
							class="exhibitor-page__section-btn-wrapper"
						>
							<v-btn
								class="exhibitor-page__section-btn elevation-0"
								@click="toggleDescription"
							>
								{{ isCollapsed ? 'Show All' : 'Hide' }}
							</v-btn>
						</div>
					</div>
				</div>

				<!-- BootStaff-->

				<div v-if="boothStaffList.length > 0" class="exhibitor-page__files mt-2">
					<h3 class="exhibitor-page__title">Booth Staff</h3>

					<BoothStaffCard
						v-for="boothStaff in boothStaffList.slice(0, 5)"
						:key="boothStaff.user_id"
						:boothStaff="boothStaff"
						backgroundColor="#F3F3F6"
					/>
					<div class="exhibitor-page__section-btn-wrapper">
						<v-btn
							class="exhibitor-page__section-btn elevation-0"
							@click="toBoothStaffPage"
						>
							Show All
						</v-btn>
					</div>
				</div>

				<!-- Файлы -->
				<div v-if="filesVisible" class="exhibitor-page__files mt-2">
					<h3 class="exhibitor-page__title">Files</h3>
					<ExhibitorFile
						v-for="file in exhibitor.uploads.slice(0, 3)"
						:key="file.upload_id"
						:file="file"
					/>
					<div class="exhibitor-page__section-btn-wrapper">
						<v-btn class="exhibitor-page__section-btn elevation-0" @click="toFilesPage">
							Show All
						</v-btn>
					</div>
				</div>

				<!-- Подарки -->
				<div v-if="giveawaysVisible" class="exhibitor-page__gives mt-2">
					<h3 class="exhibitor-page__title">Event Giveaway(s)</h3>
					<div
						v-for="giveaway in exhibitor.partnerGiveaways"
						:key="giveaway.giveaway_id"
						class="exhibitor-page__giveaway"
					>
						<img
							class="exhibitor-page__giveaway-image"
							:src="giveaway.giveaway_image"
							alt="giveaway image"
						/>
						<p class="exhibitor-page__giveaway-name">
							{{ giveaway.giveaway_name }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import PageBlocked from '@/components/PageBlocked'
import ExhibitorFile from '@/components/Event/ExhibitorFile'
import Block from '@/mixins/Block.js'
import { mapActions, mapGetters } from 'vuex'
import IconSvgSCRLAServSafe from '@/components/Resource/Icons/IconSvgSCRLAServSafe.vue'
import Avatar from '@/components/Avatar.vue'
import BoothStaffCard from '@/components/Event/BoothStaffCard.vue'

export default {
	components: {
		BoothStaffCard,
		Avatar,
		IconSvgSCRLAServSafe,
		ButtonBack,
		PageBlocked,
		ExhibitorFile,
	},
	mixins: [Block],
	data() {
		return {
			isEditing: false,
			follow_note: '',
			followStatus: this.exhibitorFollow || 0,
			mapOpen: false,
			isCollapsed: true,
			isShowAllButtonVisible: false,
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
			pageBlockedName: 'events',
		}
	},
	methods: {
		...mapActions('event', [
			'getExhibitorById',
			'followExhibitor',
			'saveFollowNote',
			'getBoothStaff',
			'deleteFollowNote',
		]),
		clearNote() {
			this.follow_note = ''
			this.deleteFollowNote({
				id: this.exhibitor.partner_id,
				follow_note: null,
			})
			this.isEditing = true
		},
		saveNote() {
			if (this.follow_note.trim() !== '') {
				this.isEditing = false
				this.saveFollowNote({
					id: this.exhibitor.partner_id,
					follow_note: this.follow_note,
				}).catch((e) => {
					console.error(e)
				})
			} else {
				this.isEditing = true
			}
		},
		onBlur() {
			this.saveNote()
			if (this.follow_note.trim() === '') {
				this.clearNote()
			}
		},
		editNote() {
			this.isEditing = true
			this.$nextTick(() => {
				this.$refs.follow_note_input.focus()
			})
		},
		bookmarksToggle() {
			const newStatus = this.followStatus ? 0 : 1

			this.followExhibitor({
				id: this.exhibitor.partner_id,
				follow_status: newStatus,
			})
				.then(() => {
					this.followStatus = newStatus
				})
				.catch((e) => {
					console.error(e)
				})
		},
		checkDescriptionLines() {
			this.$nextTick(() => {
				const description = this.$refs.description
				if (description) {
					const lineHeight = parseFloat(getComputedStyle(description).lineHeight)
					const descriptionHeight = description.scrollHeight
					const maxLinesHeight = lineHeight * 6

					this.isShowAllButtonVisible = descriptionHeight > maxLinesHeight
				}
			})
		},
		toggleDescription() {
			this.isCollapsed = !this.isCollapsed
		},

		toBoothStaffPage() {
			this.$router.push({
				name: 'exhibitor-staff',
				params: {
					id: +this.$route.params.id,
				},
			})
		},

		toFilesPage() {
			this.$router.push({
				name: 'exhibitor-files-by-id',
				params: {
					id: +this.$route.params.id,
				},
			})
		},
	},
	watch: {
		exhibitor: {
			immediate: true,
			deep: true,
			handler(newVal) {
				if (newVal) {
					this.follow_note = newVal.follow_note || ''
					this.isEditing = this.follow_note.trim() === ''
					this.followStatus = newVal.follow_status
				}
				this.checkDescriptionLines()
			},
		},
	},
	mounted() {
		this.checkDescriptionLines()
		window.addEventListener('resize', this.checkDescriptionLines)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkDescriptionLines)
	},
	computed: {
		...mapGetters('event', [
			'isLoading',
			'exhibitor',
			'exhibitorFollow',
			'exhibitorNote',
			'boothStaffList',
		]),
		groupId() {
			return parseInt(this.$route.query.group, 10) || 0
		},
		mapPartners() {
			if (this.exhibitor.mapUrl) {
				return this.exhibitor.mapUrl
			} else {
				return this.exhibitor.partner_map
			}
		},
		noteAddStyle() {
			return {
				padding: this.isEditing ? '16px 16px 0 16px' : '16px',
			}
		},
		buttonsClass() {
			return {
				'exhibitor-page__buttons': true,
				'mt-2': true,
				'four-buttons': this.buttonCount === 4,
			}
		},
		hasContactEmail() {
			return this.exhibitor && this.exhibitor.partner_contact_email !== null
		},
		hasSiteUrl() {
			return this.exhibitor && this.exhibitor.partner_site_url !== null
		},

		siteSectionVisible() {
			const { partner_site_url, partner_location, partner_name } = this.exhibitor
			return !!(partner_site_url || partner_location || partner_name)
		},
		buttonCount() {
			let count = 1
			if (this.hasContactEmail) count++
			if (this.hasSiteUrl) count++
			if (this.hasMap) count++
			return count
		},
		contactInfoVisible() {
			const {
				partner_contact_name,
				partner_contact_title,
				partner_contact_phone,
				partner_contact_email,
				partner_contact_city,
				partner_contact_state,
			} = this.exhibitor
			return !!(
				partner_contact_name ||
				partner_contact_title ||
				partner_contact_phone ||
				partner_contact_email ||
				partner_contact_city ||
				partner_contact_state
			)
		},
		descriptionVisible() {
			return !!this.exhibitor.partner_description
		},
		filesVisible() {
			return !!this.exhibitor.uploads.length
		},
		mapVisible() {
			return !!this.exhibitor.partner_map
		},
		giveawaysVisible() {
			return !!this.exhibitor.partnerGiveaways.length
		},
		locationInfo() {
			if (this.exhibitor) {
				const city = this.exhibitor.partner_contact_city
				const state = this.exhibitor.partner_contact_state
				if (city || state) {
					return `${city ? city : ''}${city && state ? ',' : ''} ${state ? state : ''}`
				}
			}
			return null
		},
	},
	created() {
		this.getBoothStaff(`partner_id=${+this.$route.params.id}`)
		this.getExhibitorById({ id: +this.$route.params.id, groupId: this.groupId })
	},
}
</script>

<style lang="scss">
.exhibitor-page__note-add__textarea .v-label {
	font-family: Montserrat, sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
	color: #aaaaaa;
}

.exhibitor-page__section-btn {
	font-size: 14px;
	color: var(--accent-color);
	background: transparent;
	text-transform: uppercase;
	cursor: pointer;
}

.exhibitor-page {
	&__content {
		margin-top: 0;
	}

	&__clear_btn {
		background-color: transparent !important;
		color: var(--button-secondary-background-color) !important;
		text-decoration: underline;
		font-size: 14px;
		font-weight: 700;
		line-height: 17.07px;
		min-width: 0;
		height: 0;
		text-transform: none;
	}

	&__logo {
		width: 100%;
		max-height: 338px;
		object-fit: contain;

		&-wrapper {
			background-color: #fff;
			border-radius: 10px;
			padding: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	&__note-add {
		background-color: #fff;
		border-radius: 10px;

		&.padding-all {
			padding: 16px;
		}

		/*&__textarea {

		}*/

		&__text-wrapper {
			display: flex;
			justify-content: space-between;
		}

		&.padding-top-sides {
			padding: 16px 16px 0 16px;
		}

		&__text {
			align-self: end;
			font-family: Montserrat, sans-serif;
			font-weight: 400;
			font-size: 14px;
			line-height: 17px;
			word-wrap: break-word;
			word-break: break-word;
			color: var(--accent-color);
		}
	}

	.exhibitor-page {
		&__buttons {
			display: flex;
			flex-wrap: nowrap;
			justify-content: space-between;
			gap: 8px;

			&__groups {
				flex: 1 2 auto;
				width: 100%;
				height: 92px;
				background-color: #fff;
				border-radius: 12px;
				text-align: center;

				a {
					text-decoration: none;
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 5px;
				}
			}

			&.four-buttons {
				@media (max-width: 479px) {
					flex-wrap: wrap;

					& > .exhibitor-page__buttons__groups {
						flex: 1 1 calc(50% - 4px);
						max-width: calc(50% - 4px);
					}
				}
			}
		}
	}

	&__icon {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	&__info-site-label {
		font-size: 14px;
		font-weight: 500;
		color: var(--accent-color);
	}

	&__gives {
		background-color: #fff;
		padding: 16px;
		border-radius: 10px;
	}

	&__map {
		background-color: #fff;
		padding: 16px;
		border-radius: 10px;
	}

	&__files {
		background-color: #fff;
		padding: 16px;
		border-radius: 10px;
	}

	&__name-location {
		background-color: #fff;
		padding: 16px;
		border-radius: 10px;
	}

	&__contact {
		background-color: #fff;
		padding: 16px;
		border-radius: 10px;
	}

	&__descriptions-section {
		background-color: #fff;
		padding: 16px;
		border-radius: 10px;
	}

	&__info {
		background-color: #fff;
		border-radius: 10px;
		font-family: Montserrat, sans-serif;
		padding: 20px 30px;

		&-site {
			color: var(--accent-color) !important;
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			text-decoration: none;
			margin-top: 12px;

			&-value {
				font-size: 13px;
				font-weight: 500;
				line-height: 19.37px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				word-break: break-word;
			}
		}

		&-name {
			color: #697583;
			font-size: 14px;
			line-height: 17.07px;

			&-label {
				color: var(--accent-color);
				font-size: 14px;
				font-weight: 700;
				line-height: 17.07px;
			}
		}

		&-location {
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			margin-bottom: 0 !important;

			&-value {
				color: #9b9b9b;
				font-size: 13px;
				font-weight: 500;
				line-height: 19.37px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				word-break: break-word;
			}

			&-icon {
				color: #9b9b9b !important;
			}
		}
	}

	&__title {
		color: #4a4a4a;
		font-size: 16px;
		font-weight: 700;
		line-height: 19.5px;
		margin-bottom: 14px;
	}

	&__section {
		&-row {
			display: flex;
			justify-content: flex-start;
			flex-wrap: nowrap;
			margin-bottom: 12px !important;

			@media (max-width: 480px) {
				flex-direction: column;
			}

			span {
				font-size: 14px;
				line-height: 17.07px;
			}

			&-title {
				color: var(--accent-color);
				font-weight: 700;
				margin-right: 12px;
			}

			&-value {
				color: #697583;
			}
		}

		&-btn {
			background-color: transparent !important;
			color: var(--button-secondary-background-color) !important;
			text-transform: capitalize;
			text-decoration: underline;
			font-size: 14px;
			font-weight: 700;
			line-height: 17.07px;

			&-wrapper {
				display: flex;
				justify-content: center;
			}
		}
	}

	&__giveaway {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;

		&-image {
			width: 100px;
			height: 100px;
			border-radius: 8px;
			object-fit: cover;
			margin-right: 16px;
		}

		&-name {
			font-size: 15px;
			font-weight: 500;
			color: var(--accent-color);
			line-height: 20px;
			margin-bottom: 0 !important;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
		}
	}

	&__description {
		font-size: 14px;
		line-height: 17.07px;
		color: var(--accent-color);
		margin-bottom: 0 !important;
	}

	&__divider {
		border-color: #e2e2e2 !important;
		margin: 24px 0;
	}
}

.v-text-field {
	padding-top: 0;
}

.v-textarea textarea {
	font-family: Montserrat, sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 1rem;
	color: var(--accent-color) !important;
}

.v-text-field__details {
	display: none;
	min-height: 14px;
}
</style>
